import { CreditCard, Link2, MailCheck, ShieldCheck, Tags } from "lucide-react";
import { Section } from "../ui/Section";

const items = [
  { icon: Tags, title: "Διαφανής τιμή", text: "Το test ξεκινά χωρίς πληρωμή. Το πλήρες premium report ξεκλειδώνει προαιρετικά με €4.90." },
  { icon: Link2, title: "Άμεση πρόσβαση", text: "Μετά την πληρωμή, το report ξεκλειδώνει online." },
  { icon: MailCheck, title: "Πρόσβαση στο report", text: "Μπορείς να επιστρέψεις στο report σου μέσω ασφαλούς link πρόσβασης." },
  { icon: CreditCard, title: "Ασφαλές checkout", text: "Η πληρωμή πραγματοποιείται μέσω ασφαλούς παρόχου πληρωμών." },
  { icon: ShieldCheck, title: "Καθαρό positioning", text: "IQ-style logic challenge με επαγγελματική αναφορά επίδοσης." }
];

export function TrustSection() {
  return (
    <Section className="py-10 sm:py-14">
      <div className="grid gap-3 md:grid-cols-5">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.title} className="rounded-2xl border border-cyan-200/10 bg-white/[0.055] p-4 shadow-[0_16px_45px_rgb(0_0_0_/_0.18),inset_0_1px_0_rgb(255_255_255_/_0.04)]">
              <Icon className="text-cyan-200" size={22} />
              <h3 className="mt-4 text-sm font-semibold text-white">{item.title}</h3>
              <p className="mt-2 text-xs leading-5 text-slate-300">{item.text}</p>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
